import React from "react";
import { useLoaderData } from "react-router";
import DraftPanel from "./panels/DraftPanel";
import ReviewPanel from "./panels/ReviewPanel";
import OutstandingPanel from "./panels/OutstandingPanel";
import SettledPanel from "./panels/SettledPanel";

export const InvoiceV2DetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.InvoiceV2DetailFrontModel>();

  return <>
    {viewModel.details.lifeCycle === "draft" && <DraftPanel
      viewModel={viewModel}
    />}
    {viewModel.details.lifeCycle === "review" && <ReviewPanel
      viewModel={viewModel}
    />}
    {viewModel.details.lifeCycle === "pending" && <OutstandingPanel
      viewModel={viewModel}
    />}
    {viewModel.details.lifeCycle === "completed" && <SettledPanel
      viewModel={viewModel}
    />}
  </>
}